module.exports = __webpack_public_path__ + "static/img/demo-3.e1bb586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/demo-3.png
// module id = fyKb
// module chunks = 1